import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/shadcn/button';
import useAuth from '@/hooks/useAuth';
import useDistributionLogo from '@/hooks/useDistributionLogo';

export default function UserCard() {
  const { t } = useTranslation();
  const { broker, signout } = useAuth();

  const logo = useDistributionLogo();

  return (
    <div className="flex w-full flex-col gap-4 rounded-lg border p-2">
      <div className="flex w-full items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <div className="bg-primary-100 text-primary-500 dark:bg-primary-800 dark:text-primary-400 flex size-12 items-center justify-center rounded-full">
            {broker?.name.slice(0, 1)}
          </div>

          <div className="flex flex-col">
            <span className="leading-tight">{broker?.name}</span>
            <span className="text-xs leading-tight">
              {broker?.distribution_name}
            </span>
            <span className="text-muted-foreground text-xs">
              {broker?.email}
            </span>
          </div>
        </div>

        <div className="flex">
          <img className="w-18" src={logo} />
        </div>
      </div>

      <Button variant="ghost" onClick={() => signout()}>
        <LogOut />

        {t('SETTINGS_SIGN_OUT')}
      </Button>
    </div>
  );
}
